import React from 'react'
import PropTypes from 'prop-types'

import { compose } from 'recompose'

import { Card, Form, Icon, Message, Modal, Popup } from 'semantic-ui-react'

import Container from './MyAccountModalContainer'
import Enhancer from './MyAccountModalEnhancer'

import Button from 'Components/StandardButton'

import { THEME_COLOR } from 'Global/constants'
import { getFormattedDateString } from 'Global/Helpers/timeHelpers'

import * as styles from './styles'

const MyAccountModal = props => {
  const { close, form, handleInputChange, handleSubmit, hasError, isPending, user } = props

  const mappedGroups = user.userGroups
    .map(group => group.name)
    .sort((a, b) => a.localeCompare(b))
    .join(', ')

  return (
    <Modal onClose={close} open={true} size="small">
      <Modal.Header>My Account</Modal.Header>

      <Modal.Content>
        <Card color={THEME_COLOR} fluid>
          <Card.Content>
            <Card.Header>{`${user.firstName} ${user.lastName}`}</Card.Header>
            <Card.Meta>{user.email}</Card.Meta>
          </Card.Content>
          <Card.Content extra>
            <Popup content="Groups" size="mini" trigger={<Icon name="address book" />} />
            {mappedGroups}
          </Card.Content>

          <Card.Content extra>
            <Popup content="Last Login" size="mini" trigger={<Icon name="calendar" />} />
            {getFormattedDateString(user.lastLogin)}
          </Card.Content>

          {hasError && (
            <Card.Content extra>
              <Message
                content={`Either the old password is not correct or the new passwords didn't match. Please try again.`}
                header="An Error Occured."
                error
              />
            </Card.Content>
          )}

          <Card.Content extra>
            <Form loading={isPending} onSubmit={handleSubmit}>
              <Form.Group>
                <Form.Field>
                  <Form.Input
                    icon="lock"
                    iconPosition="left"
                    name="passwordOld"
                    onChange={handleInputChange}
                    placeholder="Old Password"
                    type="password"
                    value={form.passwordOld}
                  />
                </Form.Field>
                <Form.Field>
                  <Form.Input
                    icon="lock"
                    iconPosition="left"
                    name="passwordNew1"
                    onChange={handleInputChange}
                    placeholder="New Password"
                    type="password"
                    value={form.passwordNew1}
                  />
                </Form.Field>
                <Form.Field>
                  <Form.Input
                    icon="lock"
                    iconPosition="left"
                    name="passwordNew2"
                    onChange={handleInputChange}
                    placeholder="Repeat New Password"
                    type="password"
                    value={form.passwordNew2}
                  />
                </Form.Field>
              </Form.Group>

              <small>After changing your password, you will be asked to sign in again.</small>

              <br />
              <div style={styles.formButton}>
                <Button content="Change Password" error={hasError} icon="setting" loading={isPending} />
              </div>
            </Form>
          </Card.Content>
        </Card>
      </Modal.Content>

      <Modal.Actions>
        <Button content="Close" icon="x" onClick={close} />
      </Modal.Actions>
    </Modal>
  )
}

MyAccountModal.propTypes = {
  close: PropTypes.func.isRequired,
  form: PropTypes.shape({
    passwordNew1: PropTypes.string.isRequired,
    passwordNew2: PropTypes.string.isRequired,
    passwordOld: PropTypes.string.isRequired,
  }).isRequired,
  handleInputChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  hasError: PropTypes.bool.isRequired,
  isPending: PropTypes.bool.isRequired,
  user: PropTypes.object.isRequired,
}

const composed = compose(
  Enhancer,
  Container,
)

export default composed(MyAccountModal)
